import React, { useContext } from 'react';
import styled from 'styled-components';
import { Header2 } from '@ubeya/shared-web/components';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import { EmptyState } from '../EmptyState';

const Title = styled(Header2)`
  margin: 30px 0;
`;

export const SearchEmptyState = ({ search }) => {
  const { t } = useContext(ConfigContext);

  return <EmptyState>{search && <Title>{t('noResults', { search })}</Title>}</EmptyState>;
};
